import { Controller } from '@hotwired/stimulus';
import { computePosition, flip, shift, offset, autoUpdate } from '@floating-ui/dom';

export default class extends Controller {
  static targets = ['menu'];
  static values = {
    placement: { type: String, default: 'bottom' },
    maxWidth: { type: String, default: 'none' },
    transform: String
  };

  connect() {
    document.addEventListener('click', this.handleOutsideClick);
    this.cleanup = null;
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick);
    if (this.cleanup) {
      this.cleanup();
      this.cleanup = null;
    }
  }

  toggle = (event) => {
    event.preventDefault();
    if (this.menuTarget.classList.contains('hidden')) {
      this.show(event.currentTarget);
    } else {
      this.hide();
    }
  }

  show(button) {
    this.menuTarget.classList.remove('hidden');
    this.menuTarget.classList.add('visible');
    const item = this.element.closest('.photos__item');
    const transform = this.hasTransformValue
      ? this.transformValue : this.menuTarget.style.transform || '';

    if (item) item.classList.add('photos__item--active');

    if (this.cleanup) {
      this.cleanup();
    }

    const placement = this.placementValue || 'bottom';

    this.cleanup = autoUpdate(button, this.menuTarget, async () => {
      const middleware = [offset(8), flip(), shift()];
      const { x, y } = await computePosition(button, this.menuTarget, {
        placement,
        middleware,
        strategy: 'fixed',
      });

      // Measure content width for dynamic sizing
      this.menuTarget.style.width = 'auto';
      this.menuTarget.style.maxWidth = 'none';
      const contentWidth = this.menuTarget.scrollWidth;
      
      // Calculate width with padding
      const calculatedWidth = contentWidth + 10;
      
      // Apply styles with calculated width
      Object.assign(this.menuTarget.style, {
        left: `${x}px`,
        top: `${y}px`,
        position: 'fixed',
        width: `${calculatedWidth}px`,
        maxWidth: this.maxWidthValue,
        transform: transform
      });
    });
  }

  hide = () => {
    this.menuTarget.classList.add('hidden');
    this.menuTarget.classList.remove('visible');
    const item = this.element.closest('.photos__item');
    if (item) item.classList.remove('photos__item--active');

    if (this.cleanup) {
      this.cleanup();
      this.cleanup = null;
    }
  }

  handleOutsideClick = (event) => {
    if (!this.element.contains(event.target)) {
      this.hide();
    }
  }
}
